import {
	call,
	put,
	takeEvery,
	takeLatest,
	takeLeading,
} from 'redux-saga/effects';

import * as Apis from '../api/User.api';
import {
	AddLinksAction,
	AddPhotossAction,
	AddSocialMediaAction,
	ADD_ACHIEVEMENTS,
	ADD_ACHIEVEMENTS_ERROR,
	ADD_ACHIEVEMENTS_SUCCESS,
	ADD_LINKS,
	ADD_LINKS_SUCCESS,
	ADD_PHOTOS,
	ADD_PHOTOS_ERROR,
	ADD_PHOTOS_SUCCESS,
	ADD_SOCIAL_MEDIA,
	ADD_SOCIAL_MEDIA_ERROR,
	ADD_SOCIAL_MEDIA_SUCCESS,
	DeleteImageAction,
	DeleteProfileImageAction,
	DELETE_IMAGE,
	DELETE_IMAGE_ERROR,
	DELETE_IMAGE_SUCCESS,
	DELETE_PROFILE_IMAGE,
	DELETE_PROFILE_IMAGE_ERROR,
	DELETE_PROFILE_IMAGE_SUCCESS,
	GetUserInfoAction,
	GET_USER_INFO,
	GET_USER_INFO_ERROR,
	GET_USER_INFO_SUCCESS,
	RemoveLinkAction,
	RemovePhotoAction,
	RemoveSocialMediaAction,
	REMOVE_ACHIEVEMENT,
	REMOVE_ACHIEVEMENT_ERROR,
	REMOVE_ACHIEVEMENT_SUCCESS,
	REMOVE_LINK,
	REMOVE_LINK_SUCCESS,
	REMOVE_PHOTO,
	REMOVE_PHOTO_ERROR,
	REMOVE_PHOTO_SUCCESS,
	REMOVE_SOCIAL_MEDIA,
	REMOVE_SOCIAL_MEDIA_ERROR,
	REMOVE_SOCIAL_MEDIA_SUCCESS,
	UPDATE_PROFILE,
	UPDATE_PROFILE_ERROR,
	UPDATE_PROFILE_SUCCESS,
	UplaodImageAction,
	UplaodProfileImageAction,
	UPLOAD_IMAGE,
	UPLOAD_IMAGE_ERROR,
	UPLOAD_IMAGE_LINKS,
	UPLOAD_IMAGE_LINKS_ERROR,
	UPLOAD_IMAGE_LINKS_SUCCESS,
	UPLOAD_IMAGE_SUCCESS,
	UPLOAD_PROFILE_IMAGE,
	UPLOAD_PROFILE_IMAGE_ERROR,
} from '../constants/ActionTypes';

function* getUserInfo({ payload, success, failed }: GetUserInfoAction) {
	try {
		const { user } = yield call(Apis.fetchUserInfo, payload);
		success?.(user);
		yield put({ type: GET_USER_INFO_SUCCESS, payload: user });
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: GET_USER_INFO_ERROR, err });
	}
}

function* updateProfile({ payload, success, failed }: GetUserInfoAction) {
	try {
		const user = yield call(Apis.updateProfileApi, payload);
		success?.(user);
		yield put({ type: UPDATE_PROFILE_SUCCESS, payload });
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: UPDATE_PROFILE_ERROR, err });
	}
}

function* uploadProfileImage({
	payload,
	success,
	failed,
}: UplaodProfileImageAction) {
	try {
		const data = yield call(Apis.imgUploadApi, payload?.data);
		yield put({
			type: UPLOAD_IMAGE_SUCCESS,
			payload: data,
		});
		if (payload && payload == '') {
			yield put({
				type: DELETE_IMAGE,
				payload: payload?.hash,
			});
		}
		yield put({
			type: UPDATE_PROFILE,
			payload: {
				profilePicture: { url: data?.data?.link, hash: data?.data?.deletehash },
			},
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: UPLOAD_PROFILE_IMAGE_ERROR, err });
	}
}

function* deleteProfileImage({
	payload,
	success,
	failed,
}: DeleteProfileImageAction) {
	try {
		yield put({
			type: UPDATE_PROFILE,
			payload: {
				profilePicture: { url: '', hash: '' },
			},
		});
		if (payload && payload == '') {
			yield put({
				type: DELETE_IMAGE,
				payload,
			});
		}
		yield put({
			type: DELETE_PROFILE_IMAGE_SUCCESS,
			payload: 'delete profile success',
		});
		success?.('delete profile success');
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: DELETE_PROFILE_IMAGE_ERROR, err });
	}
}

function* uploadImage({ payload, success, failed }: UplaodImageAction) {
	try {
		const data = yield call(Apis.imgUploadApi, payload?.data);
		success?.(data);
		yield put({
			type: UPLOAD_IMAGE_SUCCESS,
			payload: data,
		});
		yield put({
			type: ADD_PHOTOS,
			payload: {
				photos: { url: data?.data?.link, hash: data?.data?.deletehash },
			},
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: UPLOAD_IMAGE_ERROR, err });
	}
}

function* addLinks({ payload, success, failed }: AddLinksAction) {
	try {
		const data = yield call(Apis.addLinksApi, payload);
		yield put({
			type: ADD_LINKS_SUCCESS,
			payload: data,
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: ADD_PHOTOS_ERROR, err });
	}
}

function* uploadImgLinks({ payload, success, failed }: UplaodImageAction) {
	try {
		const data = yield call(Apis.imgUploadApi, payload?.links?.icon);
		yield put({
			type: UPLOAD_IMAGE_LINKS_SUCCESS,
			payload: data,
		});
		yield put({
			type: ADD_LINKS,
			payload: {
				links: {
					icon: data?.data?.link,
					url: payload?.links?.url,
					title: payload?.links?.title,
				},
			},
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: UPLOAD_IMAGE_LINKS_ERROR, err });
	}
}

function* deleteImage({ payload, success, failed }: DeleteImageAction) {
	try {
		const data = yield call(Apis.imgDeleteApi, payload);
		success?.(data);
		yield put({
			type: DELETE_IMAGE_SUCCESS,
			payload: data,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: DELETE_IMAGE_ERROR, err });
	}
}

function* addSocialMedia({ payload, success, failed }: AddSocialMediaAction) {
	try {
		const data = yield call(Apis.addSocailMediaApi, payload);
		success?.(data);
		yield put({
			type: ADD_SOCIAL_MEDIA_SUCCESS,
			payload: data,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: ADD_SOCIAL_MEDIA_ERROR, err });
	}
}

function* removeSocialMedia({
	payload,
	success,
	failed,
}: RemoveSocialMediaAction) {
	try {
		const data = yield call(Apis.deleteSocailMediaApi, payload);
		success?.(data);
		yield put({
			type: REMOVE_SOCIAL_MEDIA_SUCCESS,
			payload,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: REMOVE_SOCIAL_MEDIA_ERROR, err });
	}
}

function* removeLink({ payload, success, failed }: RemoveLinkAction) {
	try {
		const data = yield call(Apis.deleteLinkApi, payload);
		success?.(data);
		yield put({
			type: REMOVE_LINK_SUCCESS,
			payload,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: REMOVE_SOCIAL_MEDIA_ERROR, err });
	}
}

function* addAchievements({ payload, success, failed }: AddSocialMediaAction) {
	try {
		const data = yield call(Apis.addAchievementsApi, payload);
		yield put({
			type: ADD_ACHIEVEMENTS_SUCCESS,
			payload: data,
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: ADD_ACHIEVEMENTS_ERROR, err });
	}
}

function* removeAchievement({ payload, success, failed }: RemoveLinkAction) {
	try {
		const data = yield call(Apis.deleteAchieveApi, payload);
		success?.(data);
		yield put({
			type: REMOVE_ACHIEVEMENT_SUCCESS,
			payload,
		});
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: REMOVE_ACHIEVEMENT_ERROR, err });
	}
}

function* removePhoto({ payload, success, failed }: RemovePhotoAction) {
	try {
		const data = yield call(Apis.deletePhotoApi, payload?.id);
		yield put({
			type: REMOVE_PHOTO_SUCCESS,
			payload,
		});
		yield put({
			type: DELETE_IMAGE,
			payload: payload?.hash,
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: REMOVE_PHOTO_ERROR, err });
	}
}

function* addPhotos({ payload, success, failed }: AddPhotossAction) {
	try {
		const data = yield call(Apis.addPhotosApi, payload);
		yield put({
			type: ADD_PHOTOS_SUCCESS,
			payload: data,
		});
		success?.(data);
	} catch (err) {
		console.log(err);
		failed?.();
		yield put({ type: ADD_PHOTOS_ERROR, err });
	}
}

function* UserSaga() {
	yield takeEvery(GET_USER_INFO, getUserInfo);
	yield takeLeading(UPLOAD_PROFILE_IMAGE, uploadProfileImage);
	yield takeLeading(UPDATE_PROFILE, updateProfile);
	yield takeLeading(DELETE_IMAGE, deleteImage);
	yield takeLatest(ADD_SOCIAL_MEDIA, addSocialMedia);
	yield takeLatest(REMOVE_SOCIAL_MEDIA, removeSocialMedia);
	yield takeLatest(REMOVE_LINK, removeLink);
	yield takeLatest(ADD_ACHIEVEMENTS, addAchievements);
	yield takeLeading(UPLOAD_IMAGE, uploadImage);
	yield takeLatest(ADD_PHOTOS, addPhotos);
	yield takeLatest(UPLOAD_IMAGE_LINKS, uploadImgLinks);
	yield takeLatest(ADD_LINKS, addLinks);
	yield takeLatest(DELETE_PROFILE_IMAGE, deleteProfileImage);
	yield takeLatest(REMOVE_ACHIEVEMENT, removeAchievement);
	yield takeLatest(REMOVE_PHOTO, removePhoto);
}

export default UserSaga;
